export default __webpack_public_path__ + "static/media/smile.033c1168.svg";